import dayjs, { unix } from 'dayjs';
import jwt_Decode from 'jwt-decode';
import { refreshToken } from './Auth';

const baseURL = process.env.REACT_APP_URL;

export const customInterceptor = async (url) => {
  try {
    let response;
    const idToken = sessionStorage.getItem('idToken');
    const expiresIn = sessionStorage.getItem('expiresIn');
    const user = jwt_Decode(idToken);
    const isExpired = dayjs().unix(dayjs()) - user?.auth_time >= expiresIn;
    if (isExpired) {
      sessionStorage.clear('idToken');
      window.location.replace('/signin');
    } else {
      let response = await originalrequest(url, idToken);
      return response;
    }
  } catch (error) {
    throw error;
  }
};

export const originalrequest = async (url, idToken) => {
  try {
    const jsonData = await fetch(`${baseURL}/${url}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    if (!jsonData.ok && jsonData.status === 401) {
      //401 Unauthorized
      window.location.replace('/senyoError');
    } else {
      const data = await jsonData.json();
      return data;
    }
  } catch (error) {
    throw error;
  }
};
